import { render, staticRenderFns } from "./related-communities.vue?vue&type=template&id=0fac1e2f&scoped=true&"
import script from "./related-communities.vue?vue&type=script&lang=js&"
export * from "./related-communities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac1e2f",
  null
  
)

export default component.exports